import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class ForEachFuncStructuredStorageHelper extends StructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        const size = sb.scope.addUnique();
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.getStructuredStorageSize({ type: this.type }));
        sb.scope.set(sb, node, options, size);
        sb.emitHelper(node, optionsIn, sb.helpers.forEachFuncStructuredStorageBase({
            type: this.type,
            handleNext: (innerOptions) => {
                sb.scope.get(sb, node, innerOptions, size);
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.handleValueStructuredStorage);
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'ROT');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitOp(node, 'SWAP');
            },
        }));
    }
}

//# sourceMappingURL=ForEachFuncStructuredStorageHelper.js.map
